import type {
  IAvailablePaymentMethodsResponse,
  IOrderInfoResponse,
  IOrdersHistoryListResponse,
} from './models';

import { MMGatewayClient } from '../MMGatewayClient';
import { MMGatewayConfig } from '../config';

const ORDERS_NUMBER_PER_PAGE = 7; // orders count per page

class _PostcheckoutClient extends MMGatewayClient {
  public async getOrdersHistoryList(page = 0) {
    const queryParams = new URLSearchParams({
      page: page.toString(),
      service: MMGatewayConfig.SERVICE,
      limit: ORDERS_NUMBER_PER_PAGE.toString(),
      app: 'loyalty,market',
    });

    return this.get<IOrdersHistoryListResponse>(`v2/orders/history/list?${queryParams.toString()}`);
  }

  public async getOrderInfo(orderId: string) {
    return this.get<IOrderInfoResponse>(`v2/orders/info/${orderId}`);
  }

  public async getAvailablePaymentMethods() {
    const queryParams = new URLSearchParams({
      withNewPaymentMethods: 'true',
      withPayStoreOffline: 'false',
    });

    return this.get<IAvailablePaymentMethodsResponse>(`v2/payment-methods?${queryParams}`);
  }
}

export const PostcheckoutClient = new _PostcheckoutClient();
